import React from "react";
import styles from "./Bar.module.css";

function Bar(prop ) {
  return (
    <div className={styles.Barbody}>
      <div className={styles.box}>
        {prop.status === "slower" && (
          <div className={styles.scorepoint}>
            <div className={styles.dottext}>คุณอยู่ตรงนี้</div>
            <div className={styles.dot}></div>
          </div>
        )}
        <div className={styles.low}></div>
        <p className={styles.text}>ต่ำกว่าค่าเฉลี่ย</p>
      </div>
      <div className={styles.box}>
        {prop.status === "same" && (
          <div className={styles.scorepoint}>
            <div className={styles.dottext}>คุณอยู่ตรงนี้</div>
            <div className={styles.dot}></div>
          </div>
        )}
        <div className={styles.normal}></div>
        <p className={styles.text}>ค่าเฉลี่ย</p>
      </div>
      <div className={styles.box}>
        {prop.status === "faster" && (
          <div className={styles.scorepoint}>
            <div className={styles.dottext}>คุณอยู่ตรงนี้</div>
            <div className={styles.dot}></div>
          </div>
        )}
        <div className={styles.high}></div>
        <p className={styles.text}>สูงกว่าค่าเฉลี่ย</p>
      </div>
    </div>
  );
}

export default Bar;
